export default __webpack_public_path__ + "static/media/cam-left.0c3478c8.svg";